module.exports = __webpack_public_path__ + "img/EY__wavespace_md.8ecbec4d.png";